import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";
 
// ✅ Base URL
const BASE_URL = `${API_BASE_PATH}/clients`;
 
// ✅ Client Interface
export interface Client {
  client_id?: string;
  client_name: string;
  client_email: string;
  password: string;
  address: string;
  website: string;
  account_url: string;
  is_active: boolean;
  plan_id: string;
}
interface ClientData {
  client_id: string;
  CompanyName: string;
  Email: string;
  AccountURL: string;
  Plan: string;
  CreatedDate: string;
  Status: string;
  Image: string;
  client_name: string;
  
}

export interface CustomClientInfo {
  client_name: string;
  client_email: string;
  plan_price: string;
  plan_name: string;
  is_active: boolean;
  created_at: string;
}
export const fetchCustomClientInfo = async (): Promise<CustomClientInfo[]> => {
  try {
    const response = await axios.get(`${API_BASE_PATH}/get_custome_one`, {
      headers: {
        accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    toast.error("Failed to fetch custom client info");
    throw error;
  }
};


 
// ✅ Get Client Plan by client_id
export interface ClientPlanDetails {
  client_name: string;
  plan_name: string;
  plan_type: string;
  plan_price: string;
  payment_date: string;
  expire_date: string;
}
// ✅ Fetch All Clients
export const fetchClients = async (): Promise<Client[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/`);
    return response.data;
  } catch (error) {
    toast.error("Failed to fetch clients");
    throw error;
  }
};
 
// ✅ Create Client (using multipart form-data)
export const createClient = async (client: Client): Promise<void> => {
  try {
    const form = new FormData();
    form.append("client_name", client.client_name);
    form.append("client_email", client.client_email);
    form.append("password", client.password);
    form.append("plan_id", client.plan_id || "");
    form.append("website", client.website || "");
    form.append("address", client.address);
    form.append("account_url", client.account_url || "");
    form.append("is_active", client.is_active ? "true" : "false");
 
    await axios.post(`${BASE_URL}/`, form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
 
  } catch (error) {
    throw error;
  }
};
 
export const updateClient = async (client_id: string, client: any): Promise<void> => {
  try {
    const formData = new FormData();
 
    formData.append("client_name", client.client_name);
    formData.append("client_email", client.client_email);
    formData.append("password", client.password);
    formData.append("address", client.address);
    formData.append("is_active", client.is_active.toString());
    formData.append("plan_id", client.plan_id);
 
    // Optional fields if available:
    if (client.photo) {
      formData.append("photo", client.photo);
    }
    formData.append("is_deleted", "false"); // as in your curl
 
    await axios.put(`${BASE_URL}/${client_id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // ✅ important
      },
    });
 
  } catch (error) {
    console.error("Update client error:", error);
    throw error;
  }
};
 
// ✅ Delete Client
export const deleteClient = async (client_id: string): Promise<void> => {
  try {
    await axios.delete(`${BASE_URL}/${client_id}`);
  } catch (error) {
    throw error;
  }
};
 
// ✅ Fetch Plans
// types/api.ts or inline
export interface Plan {
  plan_id: string;
  plan_name: string;
}
export const fetchPlans = async (): Promise<Plan[]> => {
  const response = await axios.get(`${API_BASE_PATH}/plans/`);
  return response.data;
};
 
 
 
export const fetchClientPlan = async (
  client_id: string
): Promise<ClientPlanDetails> => {
  try {
    const response = await axios.get(
      `${API_BASE_PATH}/client/${client_id}/plan-get-method`,
      {
        headers: { accept: "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    toast.error("Failed to fetch client plan");
    throw error;
  }
};



// ✅ Update Client Plan
export const updateClientPlan = async (
  client_id: string,
  planData: {
    plan_id: string; // ✅ include this
    plan_name: string;
    plan_type: string;
    plan_price: number;
    payment_date: string;
    expire_date: string;
  }
): Promise<void> => {
  try {
    const form = new URLSearchParams();
    form.append("plan_id", planData.plan_id); // ✅ required
    form.append("plan_name", planData.plan_name);
    form.append("plan_type", planData.plan_type);
    form.append("plan_price", planData.plan_price.toString());
    form.append("payment_date", planData.payment_date);
    form.append("expire_date", planData.expire_date);

    const response = await axios.put(
      `${API_BASE_PATH}/client/${client_id}/update-plan`,
      form,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          accept: "application/json",
        },
      }
    );

    toast.success(response.data.message || "Client plan updated successfully.");
  } catch (error) {
    toast.error("Failed to update client plan");
    throw error;
  }
};


export interface ClientPlan {
  plan_id: string;
  plan_name: string;
  plan_type: string;
  plan_price: string;
}

export interface ClientDetails {
  client_id: string;
  client_name: string;
  client_email: string;
  password: string;
  address: string;
  website: string;
  account_url: string;
  is_active: boolean;
  is_deleted: boolean;
  created_at: string;
  plan: ClientPlan;
}
export const fetchClientById = async (
  client_id: string
): Promise<ClientDetails> => {
  try {
    const response = await axios.get(`${BASE_URL}/${client_id}`, {
      headers: { accept: "application/json" },
    });
    return response.data;
  } catch (error) {
    toast.error("Failed to fetch client details");
    throw error;
  }
};